import React, { createContext, useState, useEffect } from 'react';

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem('techdave-theme') || 'dark';
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('techdave-theme', theme);

    // Apply CSS variables based on theme
    if (theme === 'dark') {
      document.documentElement.style.setProperty('--color-bg-primary', '#1a1a1a');
      document.documentElement.style.setProperty('--color-bg-secondary', '#2a2a2a');
      document.documentElement.style.setProperty('--color-text-primary', '#ffffff');
      document.documentElement.style.setProperty('--color-text-secondary', 'rgba(255,255,255,0.75)');
    } else {
      document.documentElement.style.setProperty('--color-bg-primary', '#f5f5f5');
      document.documentElement.style.setProperty('--color-bg-secondary', '#e8e8e8');
      document.documentElement.style.setProperty('--color-text-primary', '#1a1a1a');
      document.documentElement.style.setProperty('--color-text-secondary', 'rgba(26,26,26,0.75)');
    }
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === 'dark' ? 'light' : 'dark'));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
